<template>
  <div id="international-roaming">
    <div class="header-container">
      <div class="inner-container d-flex">
        <div class="header-titles">
          <div :class="['header-title', this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en']">{{ title }}</div>
          <div class="mainDescription">{{ description }}</div>
          <!--          <div class="description pt-8">{{desc}}</div>-->
        </div>
        <img :class="[this.$lang === 'ar' ? 'left' : 'left', 'header-img d-block']"
          src="../../assets/images/smsRoaming1.png" class="roamingIcon">
        <div v-observe-visibility="visibilityChanged"></div>
        <div class="lottie">
          <vue-lottie-player :key="key" name="anime" ref="lottie" width="100%" height="100%"
            style="position: absolute; left: 0px; top: 0px" :animationData="jsonFile" />
        </div>
      </div>
      <div class="content-header">{{ secTitle }}</div>
    </div>
    <div class="main-content">
      <!--        <pre-paid/>-->
      <div class="upper-content">
        <lines-card :data="cardContent" :error="err" :load="lo" />
        <div class="exploreRoaming">
          <router-link to="/SMS-Roaming-Countries">
            <div class="exploreButton" tag="a">
              <div class="buttonTitle">
                <img src="../../assets/icons/exploreButton.svg" class="exploreIcon">
                {{ exploreButton }}
              </div>
              <div style="display: flex; justify-content: flex-end; align-items: center">
                <img src="../../assets/icons/exploreArrow.svg" class="exploreArrow" style="width: 20px; height: 20px">
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="additionalInfo">
      <additional-info-card :load="lo" :error="err" :data="infoText" :title="cardTitle" :section="section" />
    </div>
  </div>
</template>

<script>
import LinesCard from '../../components/cards/LinesCard'
import AdditionalInfoCard from '../../components/cards/AdditionalInfoCard'
import VueLottiePlayer from 'vue-lottie-player'
import json from '../../assets/json/smsRoaming.json'
import $ from 'jquery'
export default {
  name: 'internationalRoaming',
  components: { LinesCard, AdditionalInfoCard, VueLottiePlayer },
  props: {
    data: String,
    error: Boolean,
    load: Boolean,
    info: Array
  },
  data () {
    return {
      title: this.$t('roamingService.title'),
      description: this.$t('roamingService.description'),
      secTitle: this.$t('roamingService.secTitle'),
      exploreButton: this.$t('roamingService.exploreButton'),
      cardContent: '',
      infoText: [],
      lo: '',
      err: '',
      jsonFile: json,
      key: 0,
      section: 'SMS',
      cardTitle: this.$t('roamingService.cardTitle')
    }
  },
  watch: {
    data (val) {
      this.cardContent = val
    },
    load (val) {
      this.lo = val
    },
    error (val) {
      this.err = val
    },
    info (val) {
      this.infoText = val
    }
  },
  mounted () {
    this.arabic()
    this.cardContent = this.data
    this.infoText = this.info
    this.lo = this.load
    this.err = this.error
  },
  methods: {
    visibilityChanged (isVisible) {
      if (isVisible) {
        this.key++
        this.$forceUpdate()
      }
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.exploreRoaming, .mainDescription, .header-titles').css('direction', 'rtl')
        $('.exploreArrow, .internationalIcon').css('transform', 'rotateY(180deg)')
        $('.exploreArrow').css('transform', 'rotateY(180deg)')
        $('.mainDescription').css('font-family', 'Mtn-arabic-regular')
        $('.content-header, .buttonTitle').css('font-family', ' Mtn-arabic-bold')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.rotate {
  transform: rotateY(180deg) !important;
}

.description {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-bottom: 80px;
}

.left {
  left: 0px
}

.right {
  right: 0px;
}

.header-container {
  width: 100%;
  min-height: 400px;
  text-align: initial;
  position: relative;
  z-index: 0;
}

.inner-container {
  background: linear-gradient(45deg, rgba(255, 203, 5, 1), rgba(255, 203, 5, .5));
  min-height: 350px;
  position: relative;
  z-index: -2;

  .header-titles {
    width: 50%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .header-title {
      color: #fff;
      font-size: 30px;
      text-align: center;
    }
  }
}

.header-img {
  /*width: 325px;*/
  /*height: 350px;*/
  width: 100%;
  height: 100%;
  display: inline-block;
  position: absolute;
  bottom: 0px;
  z-index: -1;
}

#international-roaming .content-header {
  min-height: 70px;
  width: 100%;
  background: rgba(242, 242, 242, 0.7);
  backdrop-filter: blur(25px);
  position: absolute;
  z-index: 1;
  bottom: 0;
  border-top: 2px solid #fff;
  border-radius: 16px 16px 0 0;
  padding: 0 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  font-style: italic;
  font-family: Mtn-bold-italic;
  color: #FFCB05;
  padding-top: 30px;
  text-align: center;
}

.mainDescription {
  text-align: center;
  padding: 1vh 1vw;
}

.lines-tabs-container {
  height: 100%;
}

.main-content {
  min-height: calc(100vh - (400px + 170px)); // remove 285px for the footer
  background-color: rgba(242, 242, 242, .8);
  backdrop-filter: blur(25px);
  position: relative;
}

@media (max-width: 1230px) {
  img.header-img {
    height: 300px;
    width: 300px;
    bottom: 0;
    top: unset;
  }
}

@media screen and (max-width: 520px) {
  .inner-container .header-titles .header-title {
    font-size: 20px;
  }

  #international-roaming .content-header {
    font-size: 17px !important;
  }

  .mainDescription {
    font-size: 12px
  }
}

@media screen and (max-width: 1280px) {
  .description {
    padding-bottom: 0px;
  }

  .inner-container {
    /*display: block !important;*/
    margin-bottom: 50px
  }

  #international-roaming .content-header {
    bottom: -50px;
  }

  .header-titles {
    width: 90% !important;
    padding: 20px 0 !important;
  }

  img.header-img {
    display: block;
    position: unset;
    margin: 0 auto;
  }
}

.upper-content {
  background-image: url("../../assets/images/line-page-circles.svg");
  background-position: 100%;
}

#international-roaming .upper-content {
  padding-top: 25px;
}

.exploreRoaming {
  height: 250px;
  width: 100%;
  /*background-color: #ffffff7a;*/
  background-color: rgb(255 255 255 / 50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("../../assets/images/explore.png");
  /*background-size: 100% 100%;*/
  background-size: cover;
  backdrop-filter: blur(15px);
  background-position: center;
}

.exploreButton {
  width: 80vw;
  /*min-width: 300px;*/
  max-width: 570px;
  height: 70px;
  border-radius: 15px;
  background-color: #f2f2f26b;
  border: 2px #FFCB05 solid;
  display: flex;
  cursor: pointer;
  backdrop-filter: blur(5px);
}

@media screen and (max-width: 500px) {
  .buttonTitle {
    font-size: 14px !important;
  }
}

.buttonTitle {
  font-size: 18px;
  /*font-size: calc(10% + 0.5vh + 0.5vW);*/
  font-family: 'Mtn-bold-italic';
  color: #FFCB05;
  align-items: center;
  height: 100%;
  display: flex;
  text-decoration: underline;
  padding: 0 2vw;
  width: 90%;
  font-style: italic;
}

.additionalInfo {
  padding: 48px 0 30px 0;
  background-color: #F2F2F2;
  margin-bottom: -8px;
}

.exploreIcon {
  width: 30px;
  height: 30px;
  margin: 0px 12px;
}

@media screen and (max-width: 1280px) {

  #international-roaming .header-img,
  .lottie {
    display: none !important;
  }

  .header-container {
    min-height: unset !important;
    margin-bottom: 50px;
  }

  .inner-container {
    display: flex !important
  }

  #international-roaming .content-header {
    bottom: -50px;
  }
}

@media screen and (min-width: 1921px) {

  #international-roaming .header-img,
  .lottie {
    display: none !important;
  }
}
</style>
<style lang="scss">
#lines {
  .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
    color: rgba(255, 203, 5, .5) !important;
  }

  .v-tabs {
    height: 100%;
    border-bottom: 2px solid #fff;
  }

  .v-tab {
    font-size: 12px !important;
  }

  .v-tab.v-tab--active {
    color: #FFCB05;
  }

  .v-window.v-item-group.theme--light.v-tabs-items {
    background: transparent;
  }
}
</style>
